import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import AdminPage from './pages/admin';
import ProtectedRoute from './Service/ProtectedRoute';
import { getActiveUsers } from './Service/apiService';
import { Toaster } from 'react-hot-toast';

function App() {
  const [adminEmails, setAdminEmails] = useState([]);

  useEffect(() => {
    const fetchAdminEmails = async () => {
      try {
        const users = await getActiveUsers();
        const emails = users
          .map(user => user.email?.toLowerCase())
          .filter(email => !!email);
        setAdminEmails(emails);
      } catch (error) {
        console.error('Error fetching active users', error);
      }
    };

    fetchAdminEmails();
  }, []);

  return (
    <Router>
 <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedEmails={adminEmails}>
              <AdminPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
